export const environment = {
  production: false,
  envVar: {
    baseurl: "https://recon.lgtindia.in/api",
      authority: "https://login.microsoftonline.com/a69ed928-faab-4e4b-bafb-a6ecd5c9b5ef",
      clientId: "4b48e688-df32-4d79-8c81-2c1dcecd4ee3",
      redirectionUrl: "https://recon.lgtindia.in",
      postLogoutUrl: "https://recon.lgtindia.in",
      version: "1.5"
}
};
